module.exports = __webpack_public_path__ + "static/media/ht.b95c7b60.svg";